import { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login as loginApi } from '../api/auth';
import { getUser, setSession, clearSession, onRemoteLogout } from '../auth/session';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser);

  const navigate = useNavigate();

  // Another tab logged out (or its token expired): follow it.
  useEffect(() => onRemoteLogout(() => {
    setUser(null);
    navigate('/login');
  }), [navigate]);

  const login = async (username, password) => {
    const res = await loginApi(username, password);
    const { token, username: uname, shopName, role, vendorId } = res.data.data;
    const userData = { username: uname, shopName, role, vendorId };
    setSession(token, userData);
    setUser(userData);
    navigate('/');
  };

  const logout = () => {
    clearSession({ broadcast: true });
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
